import { render, staticRenderFns } from "./index.vue?vue&type=template&id=edb431c6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=edb431c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb431c6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeaderMenuBtn: require('/app/components/app/header/MenuBtn.vue').default,AppMainLogo: require('/app/components/app/MainLogo.vue').default,AppHeaderSearchInput: require('/app/components/app/header/SearchInput.vue').default,AppHeaderUserDropdown: require('/app/components/app/header/UserDropdown.vue').default,AppHeaderStoreBtn: require('/app/components/app/header/StoreBtn.vue').default,AppHeaderFavorite: require('/app/components/app/header/Favorite.vue').default,AppHeaderShoppingCartBtn: require('/app/components/app/header/ShoppingCartBtn.vue').default,AppHeaderMenuBar: require('/app/components/app/header/MenuBar.vue').default})
